import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class GrupoTaricFrItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: GrupoTaricFrViewModel[];
}

export class GrupoTaricFrViewModel {
    constructor() {}

    public Id: number;
    public Descripcion: string = '';
    public CodigoTaric: string = '';
    public IdGrupoPaisFr: number | null = null;
    public NombreGrupoPaisesFr: string = '';
    public Porcentaje: number | null = null;
    public Activo: boolean = true;
}

export class FilterSearchingGrupoTaricFrViewModel extends FilterSearchingBaseViewModel {
    public Descripcion: string = '';
    public CodigoTaric: string = '';
    public IdGrupoPaisFr: number | null = null;
    public Porcentaje: number | null = null;
    public Activo: number = EnumSiNoTodos.TODOS;
}
